import { useEffect, useState } from "react";
import { gmailStatus } from "../../lib/api";

let cache = null;
let inflight = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn(cache));

const fetchStatus = () => {
  inflight = inflight || gmailStatus().then((s) => { cache = s; return s; }).catch(() => { cache = { configured: false, accounts: [] }; return cache; }).finally(() => { inflight = null; notify(); });
  return inflight;
};

// Google connection status shared across buttons (reminders, planning). Cached per tab; call resetGoogleStatus() after changes.
export const useGoogleStatus = () => {
  const [st, setSt] = useState(cache);
  useEffect(() => {
    listeners.add(setSt);
    if (cache) setSt(cache); else fetchStatus();
    return () => listeners.delete(setSt);
  }, []);
  const accounts = st?.accounts || [];
  return {
    status: st,
    driveAccount: accounts.find((a) => a.scopes?.drive),
    calendarAccount: accounts.find((a) => a.scopes?.calendar),
    needsReconnect: accounts.length > 0 && !accounts.some((a) => a.scopes?.drive && a.scopes?.calendar),
  };
};

export const resetGoogleStatus = () => { cache = null; fetchStatus(); };
